import React from "react";
import Avatar from "./Avatar.jsx";
import UserChip from "./UserChip.jsx";
import { normalizeUser } from "../../utils/user.js";

export default function ZuweisungBadge({
  user,
  name,
  variant = "full",
  size = "sm",
  className = "",
  title,
  onClick,
  photoUrl,
  truncateAt = 0,
  maxWidth = "60vw",
  skeleton = false,
}) {
  if (skeleton) {
    const skeletonSize = size === "xs" ? "h-5 w-5" : size === "md" ? "h-8 w-8" : "h-6 w-6";
    return <span className={`inline-flex animate-pulse rounded-full bg-white/10 ${skeletonSize} ${className}`} aria-hidden="true" />;
  }

  const normalized = normalizeUser({
    ...(user || {}),
    name: user?.name || name,
    avatarUrl: user?.avatarUrl || photoUrl,
  });

  if (!normalized?.name) return null;

  if (variant === "initials") {
    const avatarSize = size === "xs" ? "xs" : size === "md" ? "md" : "sm";
    return (
      <span
        className={`inline-flex ${className}`}
        style={{ maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth }}
        title={title || normalized.name}
      >
        <Avatar user={normalized} size={avatarSize} />
      </span>
    );
  }

  const effectiveTruncateAt =
    truncateAt > 0
      ? size === "xs"
        ? Math.min(truncateAt, 14)
        : truncateAt
      : 0;
  const clippedName =
    effectiveTruncateAt > 0 && normalized.name.length > effectiveTruncateAt
      ? `${normalized.name.slice(0, Math.max(1, effectiveTruncateAt - 1))}…`
      : normalized.name;
  const chipVariant = size === "xs" ? "compact" : "badge";
  const chipSize = size === "xs" ? "xs" : size;

  return (
    <span
      className="inline-flex min-w-0"
      style={{ maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth }}
      onClick={onClick}
    >
      <UserChip
        user={{ ...normalized, name: clippedName }}
        variant={chipVariant}
        size={chipSize}
        title={title || normalized.name}
        className={className}
      />
    </span>
  );
}
